import { render, staticRenderFns } from "./ShopOwnerMenu.vue?vue&type=template&id=c5cbfae8&scoped=true&"
import script from "./ShopOwnerMenu.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerMenu.vue?vue&type=style&index=0&id=c5cbfae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cbfae8",
  null
  
)

export default component.exports